import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export function TranslationLoader(http: HttpClient) {
    return new CustomHttpTranslateLoader(http);
}

export class CustomHttpTranslateLoader implements TranslateLoader {

    constructor(
        private client: HttpClient
    ) { }

    public getTranslation(lang: string): Observable<Object> {
        return this.client.get('./assets/i18n/' + lang + '.json');
    }

}
